import { toast } from "sonner";

/**
 * Presentation Mode ("Showcase Edition") frontend helpers.
 *
 * The backend already blocks every real write for a demo account (see
 * demo_guard.py) and returns a friendly "Presentation Preview: ..."
 * message on any endpoint a demo user isn't explicitly short-circuited
 * for — so most pages need zero changes at all. For the handful of
 * flagship workflows (Running Late, Submit Expense, Request Reschedule,
 * Make Payment, Cancel Lesson) we go one step further here and simulate
 * the action entirely client-side, so it *looks* and *feels* successful
 * (dialog closes, list updates optimistically) rather than just failing
 * gracefully.
 */

export const isDemoUser = (user) => Boolean(user?.is_demo);

/** Shown for the explicitly simulated flagship workflows. */
export const simulateDemoAction = (message) => {
  toast.success(`Presentation Preview: ${message}`, { duration: 4500 });
};

export const DEMO_BANNER_TEXT =
  "Presentation Mode: You are exploring the Showcase Edition of DriveDesk Hub using sample data. Changes are disabled. Packages begin at $4,997.";

export const DEMO_CTA_FALLBACK_MESSAGE =
  "Online scheduling for demonstrations is coming soon. Please contact 815 Digital Services to schedule a personalized demonstration.";

export const DEMO_ROLE_OPTIONS = [
  {
    role: "admin",
    label: "Business Owner / Administrator",
    description: "See the complete system from the management perspective.",
  },
  {
    role: "office_staff",
    label: "Office Staff",
    description: "Experience scheduling, communication, and daily operations.",
  },
  {
    role: "instructor",
    label: "Instructor",
    description: "View schedules, navigation, running late, expenses, and student information.",
  },
  {
    role: "parent",
    label: "Parent / Student",
    description: "Schedule lessons, receive reminders, view payments, and manage your account.",
  },
];
